var shadows = {
  /** The  */
  smallest: '0 2px 3px rgba(0, 0, 0, 0.16)',
  medium: '0 5px 10px rgba(0, 0, 0, 0.1)',
  raised: '0px 2px 4px rgba(0, 0, 0, 0.02)',
  // TODO
  floating: '0px 5px 10px rgba(0, 0, 0, 0.04)',
  // Used for SiteSearch
  overlay: '0px 15px 20px rgba(0, 0, 0, 0.1)',
  // Used for SiteSearch
  dialog: '0px 20px 40px rgba(0, 0, 0, 0.2)' // TODO

};
export default shadows;